module.exports = __webpack_public_path__ + "img/134.1.cdbd5964.jpg";